import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Formsy from 'formsy-react';
import Button from '@material-ui/core/Button';
import TextInput from '../../components/forms/TextInputFormsy';

const styles = theme => ({});

class CommentForm extends Component {
	constructor(props) {
		super(props);
		this.state = { canSubmit: false };

		this.submit = this.submit.bind(this);
		this.disableButton = this.disableButton.bind(this);
		this.enableButton = this.enableButton.bind(this);
	}

	disableButton() {
		this.setState({ canSubmit: false });
	}

	enableButton() {
		this.setState({ canSubmit: true });
	}

	submit(model) {
		this.props.addComment(model.comment, this.props.challenge);
	}

	render() {
		const { classes, data } = this.props;

		return (
			<Formsy onValidSubmit={this.submit} onValid={this.enableButton} onInvalid={this.disableButton}>
				<TextInput
					// multiline
					// rows={4}
					name="comment"
					label="Comment"
					value={data && data.comment}
					style={{ maxWidth: '100%' }}
					validations="isExisty"
					validationError="Comment is required"
					required
				/>

				<Button
					variant="contained"
					color="primary"
					disabled={!this.state.canSubmit}
					type="submit"
					style={{ marginTop: 20 }}
				>
					Add Comment
				</Button>
			</Formsy>
		);
	}
}

export default withStyles(styles)(CommentForm);
